<template>
  <TooltipProvider>
    <router-view/>
    <Sonner />
  </TooltipProvider>
</template>

<script lang="ts" setup>
import './assets/index.scss'
import 'vue-sonner/style.css'
import Sonner from './components/ui/sonner/Sonner.vue'
import { TooltipProvider } from './components/ui/tooltip'
</script>

<style lang="scss">
.sonner-toast.error {
  @apply bg-red-500 text-white border-red-600;
}
</style>
